import { query } from '@/dex-shared/helpers/graphql';

export default {
  async PULL_EXAM_RESULTS({ commit }: any, examId: number) {
    const response = await query(
      `
        query GetExamResults($examId: Int!){
          getExamResultsByExamId(id: $examId) {
            id
            name
            totalQuestions
            results {
               name 
               email
               activityInMinutes
               start
               end
               correctAnswers
               wrongAnswers
               score
            }
          }
        }
      `,
      {
        examId,
      },
    );
    const examResultsResponse = response.data.getExamResultsByExamId;
    commit('SET_EXAM_RESULTS', examResultsResponse);
  },
};
